import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Depreciation} from './depreciation';
import {Supplier} from "../../setting/suppliers/supplier";

@Injectable()
export class DepreciationService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('depreciation?' + params.toString()).map((response: Response) => response.json());
    }
    deletePic(_id: string) {
        return this.http.put('org/picture/delete/' + _id,{}).map((response: Response) => response.json());
    }
    deletePic1(_id: string) {
        return this.http.put('org/picture/delete1/' + _id,{}).map((response: Response) => response.json());
    }
    getAllCurrencies() {
        return this.http.get('all/currencies').map((response: Response) => response.json());
    }
    getLogo() {
        return this.http.get('depreciation/logo').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('depreciation/' + _id).map((response: Response) => response.json());
    }


    getTrashedById(_id: string) {
        return this.http.get('depreciation/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('depreciation/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(depreciation: Depreciation) {
        return this.http.post('depreciation', depreciation).map((response: Response) => response.json());
    }

    update(depreciation: Depreciation) {
        return this.http.put('depreciation/' + depreciation.id, depreciation).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('depreciation/' + _id).map((response: Response) => response.json());
    }
    getitemstock(branch,id) {
        return this.http.get('items/'+ branch + '/'+ id).map((response: Response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/views/pro/depreciation/depreciation.service.ts